import { isStringNullOrWhiteSpace } from 'owa-strings';
/**
 * Code here is based on JSMVVM transpiled JavaScript
 */
/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
export function isValidAddress(address) {
    var isValid = IsValidSmtpAddress(address, true, true)[0];
    return isValid;
}
/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
export function isValidAddressDomain(address) {
    return IsValidDomain(address, 0, true, true);
}
var Token;
(function (Token) {
    /// <summary>MIME control character.</summary>
    Token[Token["Ctl"] = 1] = "Ctl";
    /// <summary>MIME SPEC character.</summary>
    Token[Token["Spec"] = 2] = "Spec";
    /// <summary>MIME TSPEC character.</summary>
    Token[Token["TSpec"] = 4] = "TSpec";
    /// <summary>MIME token character.</summary>
    Token[Token["Token"] = 8] = "Token";
    /// <summary>MIME atom character.</summary>
    Token[Token["Atom"] = 16] = "Atom";
    /// <summary>Digit character.</summary>
    Token[Token["Digit"] = 32] = "Digit";
    /// <summary>Hexadecimal character.</summary>
    Token[Token["Hex"] = 64] = "Hex";
    /// <summary>Linear white space character.</summary>
    Token[Token["Lwsp"] = 128] = "Lwsp";
    /// <summary>Binary character.</summary>
    Token[Token["BChar"] = 256] = "BChar";
    /// <summary>Field character.</summary>
    Token[Token["Field"] = 512] = "Field";
    /// <summary>Field character.</summary>
    Token[Token["Alpha"] = 1024] = "Alpha";
    /// <summary>Folding white space character.</summary>
    Token[Token["Fwsp"] = 2048] = "Fwsp";
})(Token || (Token = {}));
var ValidationStage;
(function (ValidationStage) {
    /// <summary>BEGIN</summary>
    ValidationStage[ValidationStage["BEGIN"] = 0] = "BEGIN";
    /// <summary>ELOCALND</summary>
    ValidationStage[ValidationStage["LOCAL"] = 1] = "LOCAL";
    /// <summary>LOCAL_DOT</summary>
    ValidationStage[ValidationStage["LOCAL_DOT"] = 2] = "LOCAL_DOT";
    /// <summary>LOCAL_DQS</summary>
    ValidationStage[ValidationStage["LOCAL_DQS"] = 3] = "LOCAL_DQS";
    /// <summary>LOCAL_ESC</summary>
    ValidationStage[ValidationStage["LOCAL_ESC"] = 4] = "LOCAL_ESC";
    /// <summary>LOCAL_DQS_ESC</summary>
    ValidationStage[ValidationStage["LOCAL_DQS_ESC"] = 5] = "LOCAL_DQS_ESC";
    /// <summary>LOCAL_DQS_END</summary>
    ValidationStage[ValidationStage["LOCAL_DQS_END"] = 6] = "LOCAL_DQS_END";
    /// <summary>DOMAIN</summary>
    ValidationStage[ValidationStage["DOMAIN"] = 7] = "DOMAIN";
    /// <summary>DOMAIN_SUB</summary>
    ValidationStage[ValidationStage["DOMAIN_SUB"] = 8] = "DOMAIN_SUB";
    /// <summary>DOMAIN_DOT</summary>
    ValidationStage[ValidationStage["DOMAIN_DOT"] = 9] = "DOMAIN_DOT";
    /// <summary>DOMAIN_LITERAL</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL"] = 10] = "DOMAIN_LITERAL";
    /// <summary>DOMAIN_LITERAL_IPV4</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV4"] = 11] = "DOMAIN_LITERAL_IPV4";
    /// <summary>DOMAIN_LITERAL_IPV4_DOT</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV4_DOT"] = 12] = "DOMAIN_LITERAL_IPV4_DOT";
    /// <summary>DOMAIN_LITERAL_I</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_I"] = 13] = "DOMAIN_LITERAL_I";
    /// <summary>DOMAIN_LITERAL_IP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IP"] = 14] = "DOMAIN_LITERAL_IP";
    /// <summary>DOMAIN_LITERAL_IPV</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV"] = 15] = "DOMAIN_LITERAL_IPV";
    /// <summary>DOMAIN_LITERAL_IPV6</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6"] = 16] = "DOMAIN_LITERAL_IPV6";
    /// <summary>DOMAIN_LITERAL_IPV6_</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_"] = 17] = "DOMAIN_LITERAL_IPV6_";
    /// <summary>DOMAIN_LITERAL_IPV6_STARTCOLON</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_STARTCOLON"] = 18] = "DOMAIN_LITERAL_IPV6_STARTCOLON";
    /// <summary>DOMAIN_LITERAL_IPV6_GRP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_GRP"] = 19] = "DOMAIN_LITERAL_IPV6_GRP";
    /// <summary>DOMAIN_LITERAL_IPV6_V4GRP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_V4GRP"] = 20] = "DOMAIN_LITERAL_IPV6_V4GRP";
    /// <summary>DOMAIN_LITERAL_IPV6_COLON</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_COLON"] = 21] = "DOMAIN_LITERAL_IPV6_COLON";
    /// <summary>DOMAIN_LITERAL_IPV6_COMP</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_IPV6_COMP"] = 22] = "DOMAIN_LITERAL_IPV6_COMP";
    /// <summary>DOMAIN_LITERAL_END</summary>
    ValidationStage[ValidationStage["DOMAIN_LITERAL_END"] = 23] = "DOMAIN_LITERAL_END";
    /// <summary>ERROR</summary>
    ValidationStage[ValidationStage["ERROR"] = 24] = "ERROR";
})(ValidationStage || (ValidationStage = {}));
var Dictionary = [
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */ | 128 /* Lwsp */ | 2048 /* Fwsp */ /* 09 (HT) */,
    1 /* Ctl */ | 128 /* Lwsp */ /* 0A (LF)*/,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */ | 128 /* Lwsp */ /* 0D (CR) */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    1 /* Ctl */,
    128 /* Lwsp */ | 2048 /* Fwsp */ | 256 /* BChar */ /* 20 SPACE */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 21 ! */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 22 " */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 23 # */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 24 $ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 25 % */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 26 & */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 27 ' */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 28 ( */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 29 ) */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 2A * */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 2B | */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 2C , */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 2D - */,
    512 /* Field */ | 8 /* Token */ | 2 /* Spec */ | 256 /* BChar */ /* 2E . */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 2F / */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 30 0 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 31 1 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 32 2 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 33 3 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 34 4 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 35 5 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 36 6 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 37 7 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 38 8 */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 32 /* Digit */ | 64 /* Hex */ | 256 /* BChar */ /* 39 9 */,
    2 /* Spec */ | 4 /* TSpec */ | 256 /* BChar */ /* 3A : */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3B ; */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3C < */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 3D = */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 3E > */,
    512 /* Field */ | 16 /* Atom */ | 4 /* TSpec */ | 256 /* BChar */ /* 3F ? */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 40 @ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 41 A */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 42 B */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 43 C */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 44 D */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 45 E */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 46 F */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 47 G */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 48 H */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 49 I */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4A J */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4B K */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4C L */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4D M */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4E N */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 4F O */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 50 P */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 51 Q */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 52 R */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 53 S */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 54 T */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 55 U */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 56 V */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 57 W */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 58 X */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 59 Y */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 5A Z */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5B [ */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5C \ */,
    512 /* Field */ | 2 /* Spec */ | 4 /* TSpec */ /* 5D ] */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 5E ^ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ /* 5F _ */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 60 ` */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 61 a */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 62 b */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 63 c */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 64 d */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 65 e */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 64 /* Hex */ | 256 /* BChar */ | 1024 /* Alpha */ /* 66 f */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 67 g */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 68 h */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 69 i */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6A j */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6B k */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6C l */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6D m */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6E n */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 6F o */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 70 p */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 71 q */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 72 r */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 73 s */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 74 t */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 75 u */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 76 v */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 77 w */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 78 x */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 79 y */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ | 256 /* BChar */ | 1024 /* Alpha */ /* 7A z */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7B { */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7C | */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7D } */,
    512 /* Field */ | 16 /* Atom */ | 8 /* Token */ /* 7E ~ */,
    1 /* Ctl */,
    /* and the rest are zero's */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
];
/**
 * Maximum length for an email name
 */
var MaxEmailName = 315; // for compatibility with TI, which accepts local part up to 315 chars, see PS:Exchange12:7056
/**
 * Maximum length for an email name for IMCEA-encapsulated X400 addresses.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 */
var MaxX400EmailName = 1604;
/**
 * Maximum length for a domain name
 */
var MaxDomainName = 255;
/**
 * Maximum length for a subdomain name
 * Labels must be 63 characters or less.
 */
var MaxSubDomainName = 63;
/**
 * Maximum length for an internet name
 */
var MaxInternetName = MaxEmailName + MaxDomainName + 1;
/**
 * Maximum length for an internet name for IMCEA-encapsulated X400 addresses.
 */
var MaxX400InternetName = MaxX400EmailName + MaxDomainName + 1;
/**
 * Parses and validates a given address per the rules specified in the RFC821
 * @param address Address to validate
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 If true, allow UTF8 characters in the email address.
 * @returns tuple containing boolean indicating whether address valid and number indicating start of domain part
 */
function IsValidSmtpAddress(address, checkLength, allowUTF8) {
    if (isStringNullOrWhiteSpace(address)) {
        // null address...
        return [false, -1];
    }
    if (checkLength && address.length > MaxInternetName) {
        if (address.length > MaxX400InternetName || !IsEncapsulatedX400Address(address)) {
            // exceeds SMTP limits...
            return [false, -1];
        }
    }
    var offset = 0;
    var state = 0 /* BEGIN */;
    while (offset < address.length && state != 24 /* ERROR */) {
        var ch = address.charAt(offset);
        var charCode = address.charCodeAt(offset);
        offset++;
        switch (state) {
            case 0 /* BEGIN */:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                if (ch == '\\') {
                    state = 4 /* LOCAL_ESC */;
                    continue;
                }
                if (ch == '"') {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 1 /* LOCAL */:
                if (ch == '@') {
                    state = 7 /* DOMAIN */;
                    offset--;
                    continue;
                }
                if (ch == '.') {
                    state = 2 /* LOCAL_DOT */;
                    continue;
                }
                // fall through...
                state = 2 /* LOCAL_DOT */;
                offset--;
                continue;
            case 2 /* LOCAL_DOT */:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                if (ch == '\\') {
                    state = 4 /* LOCAL_ESC */;
                    continue;
                }
                // error...
                break;
            case 4 /* LOCAL_ESC */:
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <dot-string> ::= <string> | <string> "." <dot-string>
                // <string> ::= <char> | <char> <string>
                // <char> ::= <c> | "\" <x>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = 1 /* LOCAL */;
                    continue;
                }
                // error...
                break;
            case 3 /* LOCAL_DQS */:
                if (ch == '"') {
                    state = 6 /* LOCAL_DQS_END */;
                    continue;
                }
                if (ch == '\\') {
                    state = 5 /* LOCAL_DQS_ESC */;
                    continue;
                }
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)
                // RFC 2821 is more restrictive on this, but we need to support old RFC821
                // With RFC 6530 adding support of UTF8 characters in the value
                if ((ch < '\x80' && '\r' != ch && '\n' != ch && '\\' != ch && '"' != ch) ||
                    (ch >= '\x80' && allowUTF8)) {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 5 /* LOCAL_DQS_ESC */:
                // RFC 821:
                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = 3 /* LOCAL_DQS */;
                    continue;
                }
                // error...
                break;
            case 6 /* LOCAL_DQS_END */:
                if (ch == '@') {
                    state = 7 /* DOMAIN */;
                    offset--;
                    continue;
                }
                // error...
                break;
            case 7 /* DOMAIN */:
                // nameLength includes the count of the '@' character
                if (checkLength && offset - 1 > MaxEmailName) {
                    if (offset - 1 > MaxX400EmailName || !IsEncapsulatedX400Address(address)) {
                        // exceeds SMTP limits...
                        return [false, -1];
                    }
                }
                if (IsValidDomain(address, offset, checkLength, allowUTF8)) {
                    return [true, offset];
                }
                // error...
                break;
            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }
        state = 24 /* ERROR */;
    }
    return [false, -1];
}
/**
 * Validates a given domain per the rules specified in the RFC821
 * @param address the domain
 * @param offset domain start offset in array
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 Whether the address should be parsed as an international (non-ASCII) address.
 * @returns whether domain is valid
 */
function IsValidDomain(address, offset, checkLength, allowUTF8) {
    if (isStringNullOrWhiteSpace(address) ||
        (checkLength && address.length - offset > MaxDomainName)) {
        // empty or exceeds SMTP limits...
        return false;
    }
    var state = 7 /* DOMAIN */;
    // domain literal validation variables
    // ... Group is a sequence of digits or hex digits . Groups are composed into address literal with
    //   appropriate delimiters.
    var group = 0; // number of groups found
    var groupChars = 0; // number of characters in the current group
    var currentGroup = 0; // value of the current group, used to check the group in ipv4 address <= 255
    var compressedIpv6 = false; // compressed form of IPv6 address found
    var subDomainStart = 0;
    var isSingleLabelDomain = true;
    while (offset < address.length && state != 24 /* ERROR */) {
        var ch = address.charAt(offset);
        var charCode = address.charCodeAt(offset);
        offset++;
        switch (state) {
            case 7 /* DOMAIN */:
                if (ch == '[') {
                    state = 10 /* DOMAIN_LITERAL */;
                    continue;
                }
                // NOTE: per RFC 2821 underscore is not allowed in a sub-domain name and
                // sub-domain name cannot start with hyphen. But... Exchange transport
                // allows underscore and hyphen anywhere in sub-domain name.
                // So we will do what transport does and allow these characters.
                // See RAID 227719 for reference.
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    subDomainStart = offset;
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 8 /* DOMAIN_SUB */:
                if (ch == '.') {
                    if (checkLength && offset - subDomainStart > MaxSubDomainName) {
                        // exceeds SMTP limits...
                        return false;
                    }
                    isSingleLabelDomain = false;
                    state = 9 /* DOMAIN_DOT */;
                    continue;
                }
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 9 /* DOMAIN_DOT */:
                if ((ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_') {
                    subDomainStart = offset;
                    state = 8 /* DOMAIN_SUB */;
                    continue;
                }
                // error...
                break;
            case 10 /* DOMAIN_LITERAL */:
                if (ch < '\x80' && IsDigit(charCode)) {
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    group = 1;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    continue;
                }
                if (ch == 'I' || ch == 'i') {
                    state = 13 /* DOMAIN_LITERAL_I */;
                    continue;
                }
                // error...
                break;
            case 11 /* DOMAIN_LITERAL_IPV4 */:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    if (currentGroup > 255) {
                        // error...
                        break;
                    }
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    continue;
                }
                if (ch == '.') {
                    state = 12 /* DOMAIN_LITERAL_IPV4_DOT */;
                    continue;
                }
                if (ch == ']' && group == 4) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 12 /* DOMAIN_LITERAL_IPV4_DOT */:
                if (ch < '\x80' && IsDigit(charCode) && group < 4) {
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = 11 /* DOMAIN_LITERAL_IPV4 */;
                    continue;
                }
                // error...
                break;
            case 13 /* DOMAIN_LITERAL_I */:
                if (ch == 'P' || ch == 'p') {
                    state = 14 /* DOMAIN_LITERAL_IP */;
                    continue;
                }
                // error...
                break;
            case 14 /* DOMAIN_LITERAL_IP */:
                if (ch == 'v' || ch == 'V') {
                    state = 15 /* DOMAIN_LITERAL_IPV */;
                    continue;
                }
                // error...
                break;
            case 15 /* DOMAIN_LITERAL_IPV */:
                if (ch == '6') {
                    state = 16 /* DOMAIN_LITERAL_IPV6 */;
                    continue;
                }
                // error...
                break;
            case 16 /* DOMAIN_LITERAL_IPV6 */:
                if (ch == ':') {
                    state = 17 /* DOMAIN_LITERAL_IPV6_ */;
                    continue;
                }
                // error...
                break;
            case 17 /* DOMAIN_LITERAL_IPV6_ */:
                if (ch < '\x80' && IsHex(charCode)) {
                    compressedIpv6 = false;
                    group = 1;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    group = 0;
                    state = 18 /* DOMAIN_LITERAL_IPV6_STARTCOLON */;
                    continue;
                }
                // error...
                break;
            case 18 /* DOMAIN_LITERAL_IPV6_STARTCOLON */:
                if (ch == ':') {
                    compressedIpv6 = true;
                    state = 22 /* DOMAIN_LITERAL_IPV6_COMP */;
                    continue;
                }
                // error...
                break;
            case 19 /* DOMAIN_LITERAL_IPV6_GRP */:
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    state = 21 /* DOMAIN_LITERAL_IPV6_COLON */;
                    continue;
                }
                if (ch == ']' &&
                    ((!compressedIpv6 && group == 8) || (compressedIpv6 && group <= 6))) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 20 /* DOMAIN_LITERAL_IPV6_V4GRP */:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    state =
                        currentGroup <= 255
                            ? 20 /* DOMAIN_LITERAL_IPV6_V4GRP */
                            : 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':') {
                    state = 21 /* DOMAIN_LITERAL_IPV6_COLON */;
                    continue;
                }
                if (ch == '.') {
                    group = 1; // we saw one IPv4 group
                    state = 12 /* DOMAIN_LITERAL_IPV4_DOT */;
                    continue;
                }
                if (ch == ']' && compressedIpv6 && group <= 6) {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 21 /* DOMAIN_LITERAL_IPV6_COLON */:
                // check: parentheses...
                if ((ch < '\x80' && IsDigit(charCode) && (!compressedIpv6 && group == 6)) ||
                    (compressedIpv6 && group <= 4)) {
                    // can have ipv4 addr at the end
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = 20 /* DOMAIN_LITERAL_IPV6_V4GRP */;
                    continue;
                }
                // check: parentheses...
                if ((ch < '\x80' && IsHex(charCode) && (!compressedIpv6 && group < 8)) ||
                    (compressedIpv6 && group < 6)) {
                    group++;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ':' && !compressedIpv6 && group <= 6) {
                    compressedIpv6 = true;
                    state = 22 /* DOMAIN_LITERAL_IPV6_COMP */;
                    continue;
                }
                // error...
                break;
            case 22 /* DOMAIN_LITERAL_IPV6_COMP */:
                if (ch < '\x80' && IsHex(charCode) && group < 6) {
                    group++;
                    groupChars = 1;
                    state = 19 /* DOMAIN_LITERAL_IPV6_GRP */;
                    continue;
                }
                if (ch == ']') {
                    state = 23 /* DOMAIN_LITERAL_END */;
                    continue;
                }
                // error...
                break;
            case 23 /* DOMAIN_LITERAL_END */:
                // any input in ValidationStage.DOMAIN_LITERAL_END state is an error
                break;
            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }
        state = 24 /* ERROR */;
    }
    // domain is good if we are in one of valid end states
    return (state == 23 /* DOMAIN_LITERAL_END */ ||
        (state == 8 /* DOMAIN_SUB */ &&
            (!checkLength || offset - subDomainStart < MaxSubDomainName) &&
            !isSingleLabelDomain));
}
function IsEncapsulatedX400Address(address) {
    return address.toUpperCase().lastIndexOf('IMCEAX400-', 0) === 0;
}
function IsAtom(ch) {
    return 0 != (Dictionary[ch] & 16 /* Atom */);
}
function IsHex(ch) {
    return 0 != (Dictionary[ch] & 64 /* Hex */);
}
function IsDigit(ch) {
    return 0 != (Dictionary[ch] & 32 /* Digit */);
}
function IsAlphaOrDigit(ch) {
    return 0 != (Dictionary[ch] & (32 /* Digit */ | 1024 /* Alpha */));
}
//# sourceMappingURL=smtpAddress.js.map